import { AnimatePresence, motion } from "framer-motion";
import { GraduationCap, Users, DollarSign, HeartHandshake } from "lucide-react";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";

import { ProcessContentImage } from "../../components/ProcessContentImage";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import Accordion from "../../components/Accordion";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/79edd2a9-ec77-409a-a55e-f747aa259195" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_imagen2.field_media_image," +
  "field_imagen3.field_media_image," +
  "field_imagen5.field_media_image," +
  "field_imagen6.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_gallery,field_gallery1,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen3,field_imagen2,field_imagen5,field_imagen6,field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

const base_URl = "https://portales.utpl.edu.ec/beportales/";
export default function Mia() {
  const DataDisplay = ({ data }) => (
    <div>
      {data.bloque1 && (
        <section className="max-w-6xl m-auto px-6 sm:px-0 py-16 mt-10">
          <div className="[&_img]:h-16 [&_img]:w-auto [&_img]:m-auto text-center max-w-3xl m-auto ">
            <ProcessContentImage
              content={data.bloque1}
              baseUrl={base_URl}
            ></ProcessContentImage>
          </div>
        </section>
      )}

      {data.bloque2 && (
        <BlockLeftImage
          src={data.imagen2}
          content={
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />
          }
        ></BlockLeftImage>
      )}

      {data.bloque3 && (
        <BlockRightImage
          src={data.imagen3}
          content={
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque3,
              }}
            />
          }
        ></BlockRightImage>
      )}
      {/* componentes  */}
      <section className="bg-slate-50">
        <div className="max-w-6xl m-auto px-6 sm:px-0 ">
          {data.bloque4 && (
            <div className="max-w-3xl   pt-16">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.bloque4,
                }}
              />
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-4 pb-16">
            {/* Bloque 5: Académico */}
            {data.bloque5 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <GraduationCap size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque5,
                  }}
                />
              </div>
            )}

            {/* Bloque 6: Administrativo */}
            {data.bloque6 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <Users size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque6,
                  }}
                />
              </div>
            )}

            {/* Bloque 7: Financiero */}
            {data.bloque7 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <DollarSign size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque7,
                  }}
                />
              </div>
            )}

            {/* Bloque 8: Psicosocial */}
            {data.bloque8 && (
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start border border-gray-100">
                <div className="p-3 bg-gray-100 rounded-lg mb-4 text-[#004270]">
                  <HeartHandshake size={28} />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.bloque8,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      {/*consejeros*/}

      <section>
        <div className="max-w-6xl m-auto px-6 sm:px-0 ">
          {data.bloque9 && (
            <div
              className="max-w-3xl m-auto text-center pt-16 pb-4
          [&_h4]:inline-block [&_h4]:bg-gray-100 [&_h4]:text-blue-700 [&_h4_strong]:text-base [&_h4]:text-base [&_h4]:px-4 [&_h4]:py-2 [&_h4]:rounded-2xl "
              dangerouslySetInnerHTML={{
                __html: data.bloque9,
              }}
            />
          )}

          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 pt-4 pb-16
            [&_h3]:font-bold"
          >
            {data.bloque10 && (
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                <div className="mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque10,
                    }}
                  />
                </div>
                <div className="mt-auto">
                  <Accordion
                    title="Carreras"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.bloque11,
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}

            {data.bloque20 && (
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                <div className="mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque20,
                    }}
                  />
                </div>
                <div className="mt-auto">
                  <Accordion
                    title="Carreras"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.bloque21,
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}

            {data.bloque12 && (
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                <div className="mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque12,
                    }}
                  />
                </div>
                <div className="mt-auto">
                  <Accordion
                    title="Carreras"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.bloque13,
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}

            {data.bloque14 && (
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                <div className="mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque14,
                    }}
                  />
                </div>
                <div className="mt-auto">
                  <Accordion
                    title="Carreras"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.bloque15,
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}

            {data.bloque16 && (
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                <div className="mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque16,
                    }}
                  />
                </div>
                <div className="mt-auto">
                  <Accordion
                    title="Carreras"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.bloque17,
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}

            {data.bloque18 && (
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                <div className="mb-6">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque18,
                    }}
                  />
                </div>
                <div className="mt-auto">
                  <Accordion
                    title="Carreras"
                    content={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.bloque19,
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div className="[&_h3]:font-bold">
            {data.bloque22 && (
              <div
                className="max-w-3xl m-auto text-center pt-16 pb-4
                 [&_h4]:inline-block [&_h4]:bg-gray-100 [&_h4]:text-blue-700 [&_h4_strong]:text-base [&_h4]:text-base [&_h4]:px-4 [&_h4]:py-2 [&_h4]:rounded-2xl"
                dangerouslySetInnerHTML={{
                  __html: data.bloque22,
                }}
              />
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-6xl mx-auto pt-4 pb-16">
              {data.bloque23 && (
                <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                  <div className="mb-6">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.bloque23,
                      }}
                    />
                  </div>
                  <div className="mt-auto">
                    <Accordion
                      title="Programas"
                      content={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.bloque24,
                          }}
                        />
                      }
                    />
                  </div>
                </div>
              )}

              {data.bloque25 && (
                <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                  <div className="mb-6">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.bloque25,
                      }}
                    />
                  </div>
                  <div className="mt-auto">
                    <Accordion
                      title="Programas"
                      content={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.bloque26,
                          }}
                        />
                      }
                    />
                  </div>
                </div>
              )}

               {data.bloque27 && (
                <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col justify-between">
                  <div className="mb-6">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.bloque27,
                      }}
                    />
                  </div>
                  <div className="mt-auto">
                    <Accordion
                      title="Programas"
                      content={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.bloque28,
                          }}
                        />
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {data.bloque29 && (
        <div
        className="text-center max-w-6xl m-auto px-6 sm:px-0 button-a py-10 [&_a]:m-auto"
          dangerouslySetInnerHTML={{
            __html: data.bloque29,
          }}
        />
      )}
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => (
        <AnimatePresence mode="wait">
          <DataDisplay key="data-loaded" data={data} />
        </AnimatePresence>
      )}
    </DataFetcherTemplateHome2>
  );
}
